module.exports = __webpack_public_path__ + "static/img/gaozhongwuli3.cbc2d516.jpg";